const publicLayout = {
  nav: {
    about: "About",
    security: "Security",
    roadmap: "Roadmap",
  },
  adminNav: {
    overview: "Overview",
    users: "Users",
    projects: "Projects",
    dataRequests: "Requests to review",
    datasets: "Datasets",
  },
  brand: {
    tagline: "Pseudonymization service",
  },
  header: {
    dashboard: "Dashboard",
    login: "Log in",
  },
  footer: {
    marketing: {
      description:
        "A pseudonymization service for health research: researchers get the data, nobody gets the identities. Built for university departments, institutes, and research units — and for the hospitals and registries that supply them with data.",
      readHeading: "Read",
      accessHeading: "Access",
      invitationOnly: "Accounts are issued by invitation only.",
      dayToDayQuestions:
        "Day-to-day questions: your project's principal investigator, or your department's manager.",
      contactBefore: "Suggestions, bug reports, a new department:",
      inDevelopment: {
        before: "In active development — See the",
        roadmapLink: "roadmap",
        after: "for current status.",
      },
      technicalControlNote:
        "Pseudonymization is a technical control, not a substitute for ethics approval.",
    },
    app: {
      title: "Pseudonymization Service",
      subtitle: "Secure, context-aware pseudonymization of research data",
      about: "About & guide",
      security: "Security",
      roadmap: "Roadmap",
    },
  },
};

export default publicLayout;
